import {animate, state, style, transition, trigger, useAnimation} from "@angular/animations";

export const FadeInOutAnimation = trigger('fadeInOut', [
  state('visible', style({
    opacity: 1,
    height: '*',
    overflow: 'visible'
  })),

  state('hidden', style({
    opacity: 0,
    height: '0px',
    overflow: 'hidden'
  })),

  transition('visible => hidden', [
    animate('150ms ease-in')
  ]),

  transition('hidden => visible', [
    animate('250ms ease-out')
  ])
]);
